export default __webpack_public_path__ + "static/media/reddit-white.5dd95155.png";